import { IconPropsType } from "./types/IconsProps.type";

type SidebarHeaderIconProps = & IconPropsType

export const SidebarHeaderIcon = ({
    width = 20,
    height = 20,
    className = '',
    style = {},
    fillColor = 'currentColor',
}: SidebarHeaderIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                d="M4.16732 6.08317C3.84515 6.08317 3.58398 6.34434 3.58398 6.6665C3.58398 6.98867 3.84515 7.24984 4.16732 7.24984H5.83398C6.15615 7.24984 6.41732 6.98867 6.41732 6.6665C6.41732 6.34434 6.15615 6.08317 5.83398 6.08317H4.16732Z"
                fill={fillColor}
            />
            <path
                d="M3.58398 8.33317C3.58398 8.011 3.84515 7.74984 4.16732 7.74984H5.83398C6.15615 7.74984 6.41732 8.011 6.41732 8.33317C6.41732 8.65534 6.15615 8.9165 5.83398 8.9165H4.16732C3.84515 8.9165 3.58398 8.65534 3.58398 8.33317Z"
                fill={fillColor}
            />
            <path
                d="M4.16732 9.4165C3.84515 9.4165 3.58398 9.67767 3.58398 9.99984C3.58398 10.322 3.84515 10.5832 4.16732 10.5832H5.83398C6.15615 10.5832 6.41732 10.322 6.41732 9.99984C6.41732 9.67767 6.15615 9.4165 5.83398 9.4165H4.16732Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.08398 5.83317C1.08398 4.59053 2.09134 3.58317 3.33398 3.58317H16.6673C17.91 3.58317 18.9173 4.59053 18.9173 5.83317V14.1665C18.9173 15.4091 17.91 16.4165 16.6673 16.4165H3.33398C2.09134 16.4165 1.08398 15.4091 1.08398 14.1665V5.83317ZM3.33398 4.74984C2.73568 4.74984 2.25065 5.23486 2.25065 5.83317V14.1665C2.25065 14.7648 2.73568 15.2498 3.33398 15.2498H7.75065V4.74984H3.33398ZM16.6673 15.2498H8.91732V4.74984H16.6673C17.2656 4.74984 17.7507 5.23486 17.7507 5.83317V14.1665C17.7507 14.7648 17.2656 15.2498 16.6673 15.2498Z"
                fill={fillColor}
            />
        </svg>
    );
}
